module.exports = __webpack_public_path__ + "img/gbp.0f68aba7.svg";